import lsLog from './localStorage.log';

function parseIn(raw: unknown) {
  try {
    return JSON.stringify(raw);
  } catch (err) {
    lsLog.error('STRINGIFY', err);

    return null;
  }
}

function parseOut<T>(raw: string | null, initialValue: T): T;

function parseOut<T>(raw: string | null, initialValue?: T): T | undefined;

function parseOut<T>(raw: string | null, initialValue?: T): T | undefined {
  try {
    return raw ? JSON.parse(raw) : initialValue;
  } catch (err) {
    lsLog.error('PARSE', err);

    return initialValue;
  }
}

const parser = {
  in: parseIn,
  out: parseOut,
};

export default parser;
